import { motion } from "framer-motion";

export const SQUIRE_URL = "https://getsquire.com/booking/book/faded-barber-co-springfield";
export const PHONE_TEL = "tel:+15713781396";
export const PHONE_DISPLAY = "(571) 378-1396";
export const ADDRESS_LINE = "6803 Backlick Rd # B";
export const ADDRESS_CITY = "Springfield, VA 22150";
export const EMAIL = "info@thefadedbarberco.com";
export const APP_STORE_URL = "https://apps.apple.com/us/app/faded-barber-co/id6744754110";
export const DIRECTIONS_URL =
  "https://www.google.com/maps/dir/?api=1&destination=Faded+Barber+Co,+6803+Backlick+Rd+%23+B,+Springfield,+VA+22150";
export const GOOGLE_LISTING_URL =
  "https://www.google.com/maps/search/?api=1&query=Faded+Barber+Co+6803+Backlick+Rd+Springfield+VA+22150";

export const BookLink = ({ className = "", children, testid = "book-cta", ...props }) => (
  <a
    href={SQUIRE_URL}
    target="_blank"
    rel="noopener noreferrer"
    data-testid={testid}
    className={className}
    {...props}
  >
    {children}
  </a>
);

export const Reveal = ({ children, delay = 0, className = "", ...props }) => (
  <motion.div
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
    {...props}
  >
    {children}
  </motion.div>
);

export const Chapter = ({ index, title }) => (
  <Reveal className="flex items-center gap-4 mb-10">
    <span className="w-6 h-6 pole-stripes shrink-0" aria-hidden="true" />
    <span className="font-mono text-sm text-primary tracking-[0.3em]">{index}</span>
    <span className="h-px flex-1 bg-border" aria-hidden="true" />
    <span className="overline">{title}</span>
  </Reveal>
);
